<template>
  <v-row>
    <v-container fluid class="soft-grey" id="about-me">
      <v-row class="px-8 mt-7">
        <Header :value="'Несколько слов о том, как я понимаю психотерапию'"/>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center" :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12" >
          <v-img
            class="my-auto"
            max-height="100vh"
            src="../../public/pictures/about/1.jpg"
          />
        </v-col>
        <v-col class="d-flex flex-column justify-center title text-center font-weight-light mx-8">
          Психотерапевт - не эксперт, который даст вам готовый ответ, а, скорее, проводник, который поможет
          найти пути решения. Используя метафору, психотерапию можно сравнить с путешествием по темному,
          неизведанному лесу: клиент здесь выступает как «путешественник», главное действующее лицо, а
          терапевт только сопровождает его на этом пути.
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="soft-grey" >
      <v-row>
        <v-col  class="d-flex flex-column justify-center title text-center font-weight-light mx-8 my-auto">
          <v-col>
            В чем же состоят функции психотерапевта, если он не дает готовую «карту» (ответы)? Помочь осветить
            дорогу, где становятся видны все наши трудности, неровности, ямы, и тогда путешественнику будет уже
            проще справиться с ними или обойти.
          </v-col>
          <v-col>
            Кроме того, когда психолог достает свой фонарик, мы видим не
            только ухабы, но скрытые в лесу ручейки, растущие там ягоды, которыми можно подкрепиться в дороге
            (становятся видимыми наши ресурсы). Иногда путешественника могут преследовать тени (следы наших
            прошлых травм). Тогда «фонарик» терапевта поможет либо отогнать их (на время, пока мы не обнаружим
            ресурсы для встречи с ними), либо вступить с ними в диалог.
          </v-col>
          <v-col>
            Кроме того, на дороге можно найти
            «зарытые клады» (наши бессознательные защиты, желания, стремления), которые ранее оставались в тени.
          </v-col>
        </v-col>
        <v-col class="d-flex justify-center" :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
          <v-img
            class="my-auto"
            max-height="100vh"
            src="../../public/pictures/about/2.jpg"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="soft-grey" >
      <v-row style="max-width: 720px;" class="mx-auto">
        <v-col class="title text-center font-weight-light mx-8 my-auto">
          Так, шаг за шагом, вместе с психотерапевтом клиент постепенно продвигается вперед к намеченной цели,
          параллельно с этим выстраивая «карту» своего внутреннего мира, чтобы, используя эту карту и получив
          необходимые навыки, двигаться самому на пути изменений и самопознания.
        </v-col>
      </v-row>
    </v-container>
    <!--образование-->
    <v-container fluid>
      <v-row>
        <Header :value="'Образование'"/>
      </v-row>
      <v-row class="mx-auto title text-left" style="max-width: 720px">
        <v-col cols="12" class="font-weight-bold px-8">
          Высшее психологическое образование:
        </v-col>
        <v-col cols="12" class="font-weight-light">
          <v-list>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-circle-small</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Факультет психологии МГУ им М.В. Ломоносова, специальность «Клиническая
                психология», специализация «Психотерапия и психоаналитическое консультирование», 2012-2019.
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" class="font-weight-bold px-8">
          Повышения квалификации:
        </v-col>
        <v-col cols="12" class="font-weight-light">
          <v-list>
            <v-list-item
              v-for="(item, i) in education"
              :key="i">
              <v-list-item-icon>
                <v-icon>mdi-circle-small</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{item.name}}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="section-height" v-if="$vuetify.breakpoint.lgAndUp">
      <!--          todo: переделать через картинки-->
      <v-carousel v-model="model" light height="inherit">
        <v-carousel-item
          v-for="(item, index) in articles"
          :key="index"
        >
          <v-row
            align="center"
            justify="center"
          >
            <img :alt="item.title"
                 v-for="page in item.pages"
                 :key="page"
                 :src="page"
                 style="height: 80vh;"
            />
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </v-container>
    <v-container v-else>
      <v-row v-for="({ pages, title }, i) in articles"
             :key="i"
             cols="12"
             class="ma-3">
        <v-col class="d-flex justify-center">
          <v-btn
            height="30vh"
            @click.stop="dialog = true; numberOfDiploma = i"
            style="box-shadow: none; height: 30vh; border-radius: 0;"
          >
            <div class="diploma-for-mobile" style="background: #eeeeee">
              <img
                :src="pages[0]"
                class="pages-of-diploma"
              />
            </div>
          </v-btn>
        </v-col>
        <v-col class="ma-auto">
          <h3
            class="font-weight-black text-uppercase text-center"
            v-text="title"
          ></h3>
        </v-col>
      </v-row>
    </v-container>
    <!--модальное окно с дипломами-->
    <v-dialog
      v-model="dialog"
      scrollable max-width="max-content"
    >
      <v-card @click="dialog = false">
        <img alt=""
             v-for="page in articles[numberOfDiploma].pages"
             :key="page"
             :src="page"
             style="max-height: 90vh"
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Header from "@/components/Header";

export default {
  name: 'About',
  components: {Header},
  data() {
    return {
      education: [
        {name: 'Основы телесно-ориентированной психотерапии, Фонд «Будущее Сейчас». 2017-2018.'},
        {name: 'Нарративная практика, Фонд «Будущее Сейчас». 2017-2018.'},
        {name: 'Работа с образами и метафорами в психотерапии, «Учебный центр Профессионал». 2018.'},
        {name: 'Метод обнаружения персональных ценностей, Ассоциация Экзистенциально-Аналитических Психологов и Психотерапевтов (AEAPP), 2019.'},
        {name: 'Международная сертификационная программа по процессуально-ориентированной психотерапии, «Международный центр процессуальной работы (ICPW)», 2020-2021.'},
        {name: 'Школа интегративно-соматической психотерапии, Телесно-ориентированная терапия с элементами биоэнергетического анализа А. Лоуэна, 2021-2022'},
        {name: 'Основы схема-терапии "Чистые когниции", 2025-2025'},
        {name: 'Психоаналитическая диагностика. Понимание структуры личности в клиническом процессе. Международная академия психодинамической психотерапии, 2026-2026.'},
      ],
      model: 0,
      dialog: false,
      numberOfDiploma: 0,
      articles: [
        {
          src: 'pdf/Diploma.pdf',
          title: 'высшее образование',
          pages: ['diplomas/Diploma_page-0001.jpg', 'diplomas/Diploma_page-0002.jpg', 'diplomas/Diploma_page-0003.jpg'],
          text: 'Phasellus lorem enim, luctus ut velit eget, ',
        },
        {
          src: 'pdf/Sertificats-1-2.pdf',
          title: 'повышение квалификации',
          pages: ['diplomas/Sertificats-1-2_page-0001.jpg', 'diplomas/Sertificats-1-2_page-0002.jpg'],
          text: 'Nam ut leo ipsum. Maecenas pretium aliquam feugiat. ',
        },
        {
          src: 'pdf/Sertificats-3.pdf',
          title: 'повышение квалификации',
          pages: ['diplomas/Sertificats-3_page-0001.jpg'],
          text: 'Vestibulum in dictum velit, in rhoncusellus lorem enim, luctus ut velit eget.',
        },
        {
          src: 'pdf/Sertificats-2.pdf',
          title: 'повышение квалификации',
          pages: ['diplomas/Sertificats-2_page-0001.jpg'],
          text: 'Vestibulum in dictum velit, Phasellus lorem enim, luctus ut velit eget.',
        },
        {
          src: 'pdf/Diploma2.pdf',
          title: 'повышение квалификации',
          pages: ['diplomas/Diploma2.jpg'],
          text: 'Vestibulum in dictum velit, Phasellus lorem enim, luctus ut velit eget.',
        },
        {
          src: 'pdf/Sertificats-4.pdf',
          title: 'повышение квалификации',
          pages: ['diplomas/Sertificate-4.jpg'],
          text: 'Vestibulum in dictum velit, Phasellus lorem enim, luctus ut velit eget.',
        },
        {
          src: 'pdf/Sertificate-5.pdf',
          title: 'повышение квалификации',
          pages: ['diplomas/Sertificats-5.jpg'],
          text: 'Vestibulum in dictum velit, Phasellus lorem enim, luctus ut velit eget.',
        },
        {
          src: 'pdf/Sertificate-6.pdf',
          title: 'повышение квалификации',
          pages: ['diplomas/Sertificats-6.png'],
          text: 'Vestibulum in dictum velit, Phasellus lorem enim, luctus ut velit eget.',
        },
      ],
    }
  },

  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>


<style>
.v-application a {
  text-decoration: none;
}

.soft-grey {
  background-color: #eeeeee
}

.diploma-for-mobile {
  display: flex;
  height: 30vh;
}

.pages-of-diploma {
  height: inherit;
}
</style>
